<template>
	<BaseLoading v-if="edit.isLoading" />
	<ProductLabelEditForm
		v-else
		v-model="data"
		@submit="handleSubmit"
	/>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ProductLabelEditForm from '@/components/ProductLabelEditForm.vue';

export default {
	name: 'ProductLabelEdit',

	components: {
		ProductLabelEditForm,
	},
	data() {
		return {
			data: {},
			id: this.$route.params.id || null,
		};
	},
	computed: {
		...mapState('productLabels', {
			edit: 'edit',
		}),
		...mapGetters({
			label: 'productLabels/getLabel',
		}),
	},
	watch: {
		label: {
			deep: true,
			handler(label) {
				this.data = label;
			},
		},
	},
	async created() {
		await this.getProductLabel(this.id);

		this.data = this.label;
		this.updatePageTitle();
	},
	methods: {
		...mapActions({
			getProductLabel: 'productLabels/getProductLabel',
			setPageTitle: 'pageTitle/setPageTitle',
		}),

		updatePageTitle() {
			this.setPageTitle({
				title: this.label.name,
				isShow: true,
			});
		},
		handleSubmit() {
			this.updatePageTitle();
		},
	},
};
</script>
